import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Cash',
  icon: 'mdi-cash',
  path: '/reports/mcd/controlsCash/',
  children: [
    {
      path: '/reports/mcd/controlsCash/cashsheet',
      name: 'Cash Sheet',
      meta: { id: 'reports-cashSheet' },
      component: () => import('./cashSheet/CashSheet.vue'),
      ...addPermissionsToRoute(['cashSheetDashboard']),
    },
    {
      path: '/reports/mcd/controlsCash/cashStatistics',
      name: 'Cash Statistics',
      meta: { id: 'reports-cashStatistics' },
      component: () => import('@/views/standard/cash/cashStatistics.vue'),
      ...addPermissionsToRoute(['cashStatistics']),
    },
    {
      path: '/reports/mcd/controlsCash/adyenVariance',
      name: 'Adyen',
      meta: { id: 'reports-adyenVarianceSummary' },
      component: () => import('./adyen/adyenWrapper.vue'),
      ...addPermissionsToRoute(['cashless']),
    },
    {
      path: '/reports/mcd/controlsCash/registerAudit',
      name: 'Register Audit',
      meta: { id: 'reports-registerAudit' },
      component: () => import('./registerAudit/registerAudit.vue'),
      ...addPermissionsToRoute(['registerAudit']),
    },
    {
      path: '/reports/mcd/controlsCash/giftCardSummary',
      name: 'Gift Card Summary',
      meta: { id: 'reports-giftCardSummary' },
      component: () => import('./giftCardSummary.vue'),
      ...addPermissionsToRoute(['cashless']),
    },
    {
      path: '/reports/mcd/controlsCash/cashless',
      name: 'Cashless',
      meta: { id: 'reports-cashlessDetail' },
      component: () => import('./cashless/CashlessWrapper.vue'),
      ...addPermissionsToRoute(['cashless']),
    },
    {
      path: '/reports/mcd/controlsCash/deposits',
      name: 'Deposits',
      meta: { id: 'reports-depositDetails' },
      component: () => import('./deposits/DepositsWrapper.vue'),
      ...addPermissionsToRoute(['deposits']),
    },
    {
      path: '/reports/mcd/controlsCash/taxDetails',
      name: 'Tax Details',
      meta: { id: 'reports-taxDetails' },
      component: () => import('./taxDetails.vue'),
      ...addPermissionsToRoute(['taxDetails']),
    },
    {
      path: '/reports/mcd/controlsCash/taxExempt',
      name: 'Tax Exempt',
      meta: { id: 'reports-taxExempt' },
      component: () => import('./taxExempt/TaxExemptWrapper.vue'),
      ...addPermissionsToRoute(['taxExempt']),
    },
    {
      path: '/reports/mcd/controlsCash/otherReceipts',
      name: 'Other Receipts',
      meta: { id: 'reports-otherReceiptsSummary' },
      component: () => import('./otherReceipts/OtherReceiptsWrapper.vue'),
      ...addPermissionsToRoute(['otherReceipts']),
    },
    {
      path: '/reports/mcd/controlsCash/billableSales',
      name: 'Billable Sales',
      meta: { id: 'reports-billableSales' },
      component: () => import('./BillableSales.vue'),
      ...addPermissionsToRoute(['billableSales']),
    },
    {
      path: '/reports/mcd/controlsCash/safeCounts',
      name: 'Safe Counts',
      meta: { id: 'reports-safeCounts' },
      component: () => import('./SafeCounts.vue'),
      ...addPermissionsToRoute(['safeCounts']),
    },
  ],
};

export default routes;
